<template>
  <div class="bg-blue-600">
    <div class="" style="text-align: center">
      <div class="p-2">
        <img
          class="h-16"
          src="../assets/images/logo-horizontal.png"
          alt="Logo"
          style="display: block; margin: auto"
        />
        <p class="text-xs text-center text-white mt-1">
          © 2020. Todos los Derechos Reservados.
        </p>
        <a
          class="text xs text-center text-white mb-1"
          href="https://www.lineamagisterial.com/aviso.php"
          target="_blank"
          >Aviso de Privacidad - Aviso Legal</a
        >
        <p class="text xs text-center text-white mb-1">v 2020.10.26</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>
